import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Component } from "react";
import * as Yup from "yup";
import UserService from "../../services/UserService";
import UserEntity from "../../types/userEntity.type";
import EmptyModeratorsView from "./EmptyModeratorsView";
import ModeratorsList from "./ModeratorsList";

type Props = {};

type State = {
  users: UserEntity[];
  user?: UserEntity;
  loading?: boolean;
  message?: string;
  searchLoading?: boolean;
  searchMessage?: string;
};

export default class ModeratorsView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.searchUser = this.searchUser.bind(this);

    this.state = {
      users: [], // Initialize as empty array
      user: undefined, // Avoid using `new Object()`
    };
  }

  componentDidMount() {
    this.getAllModerators();
  }

  getAllModerators() {
    UserService.getModeratorsBoard().then(
      (response) => {
        // Ensure response.data is an array; fallback to empty array if not
        const users = Array.isArray(response.data) ? response.data : [];
        this.setState({
          users,
          loading: false,
          message: undefined,
        });
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          users: [], // Keep users as an empty array on error
          loading: false,
          message: resMessage,
        });
      }
    );
  }

  searchUser(searchValue: React.ChangeEvent<HTMLInputElement>) {
    const value = searchValue.target.value;

    if (value.length > 0) {
      UserService.searchUser(value).then(
        (response) => {
          // Ensure response.data is an array; fallback to empty array if not
          const users = Array.isArray(response.data) ? response.data : [];
          this.setState({
            users,
            searchLoading: false,
            searchMessage: undefined,
          });
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            users: [], // Keep users as an empty array on error
            searchLoading: false,
            searchMessage: resMessage,
          });
        }
      );
    } else {
      this.getAllModerators();
    }
  }

  validationSchema() {
    return Yup.object().shape({
      searchValue: Yup.string().required("This field is required!"),
    });
  }

  render() {
    const initialValues = { searchValue: "" };
    const { searchLoading, searchMessage, user, users } = this.state;

    const searchForm = (
      <Formik
        initialValues={initialValues}
        validationSchema={this.validationSchema()}
        enableReinitialize={true}
        onSubmit={(values) => this.searchUser({ target: { value: values.searchValue } } as any)}
      >
        <Form>
          <div className="form-group">
            <Field name="searchValue" type="text" className="form-control" onChange={this.searchUser} />
            <ErrorMessage name="searchValue" component="div" className="alert alert-danger" />
          </div>
          {searchLoading && searchMessage && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {searchMessage}
              </div>
            </div>
          )}
        </Form>
      </Formik>
    );

    // Ensure users is an array before filtering
    const filtered = Array.isArray(users)
      ? users.filter((el) => el.email !== user?.email)
      : [];

    const view = filtered.length > 0 ? (
      <ModeratorsList listItems={filtered} />
    ) : (
      <EmptyModeratorsView />
    );

    return (
      <div className="container">
        {searchForm}
        {view}
      </div>
    );
  }
}